import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import authReducer from './reducer/auth.reducer';
import fanReducer from './reducer/fan.reducer';
import projectReducer from './reducer/project.reducer';
import BladeModelReducer from './reducer/bladeModal.reducer';
import HubModelReducer from './reducer/hubModal.reducer';
import GaDrawingModelReducer from './reducer/gaDrawingModal.reducer';
import OctaveBandModelReducer from './reducer/octaveBandModal.reducer';
import FanUploadModelReducer from './reducer/fanUpload.reducer';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    fan: fanReducer,
    project: projectReducer,
    bladeModel: BladeModelReducer,
    hubModel: HubModelReducer,
    gaDrawingModel: GaDrawingModelReducer,
    octaveBandModel: OctaveBandModelReducer,
    fanUploadModel: FanUploadModelReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
